<template>
  <div class="start">
    <div class="s-content">
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
        alt=""
      />
      <div class="text-1">在开始蜕变之旅前，请花3-5分钟完成..</div>
      <img
        class="title-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0408bb496ec627ab6af44e6b031e815e.png"
        alt=""
      />
      <div class="desc">身体状态、饮食结构、生活习惯三大维度</div>
      <div class="list">
        <div class="item">
          <span class="iconfont icon-gou"></span>
          <span>全面把控减脂方向</span>
        </div>
        <div class="item">
          <span class="iconfont icon-gou"></span>
          <span>精准定位健康难题</span>
        </div>
        <div class="item">
          <span class="iconfont icon-gou"></span>
          <span>解锁个性化尊享服务</span>
        </div>
      </div>
      <div class="text-2"
        >本问卷由betterWE权威营养专家团队研发，采用国际营养学界主流的远程信息收集法—【膳食频率问卷法(FFQs)】</div
      >
      <div class="start-btn" @click="bindClick">开始填写</div>
      <div class="tips"
        ><span class="star">*</span
        ><span> 问卷信息仅用于个人营养评估</span></div
      >
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  components: {},
  data() {
    return {}
  },
  created() {
    this.token = Cookies.get('join-camp-token')
    if (!this.token) {
      this.$router.push('/join-camp-question-v2/login')
    }
  },
  methods: {
    bindClick() {
      this.$router.push({
        path: '/join-camp-question-v2/question',
        query: this.$route.query
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.start {
  background: linear-gradient(180deg, #f9f9f9 0%, #fdfdfd 100%);
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/079b465336f86d97b70c13025c089fec.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100%;
  .s-content {
    padding: 77px 36px 96px;

    .logo {
      height: 12px;
      margin-bottom: 6px;
    }

    .text-1 {
      font-size: 13px;
      color: rgba(55, 46, 37, 0.9);
      line-height: 24px;
      padding-bottom: 6px;
      border-bottom: 2px solid #372e25;
      margin-bottom: 5px;
    }

    .title-image {
      width: 273px;
      height: 128px;
      margin-bottom: 4px;
    }

    .desc {
      font-size: 15px;
      color: #372e25;
      line-height: 24px;
      margin-bottom: 10px;
    }

    .list {
      font-size: 13px;
      color: rgba(0, 0, 0, 0.5);
      margin-bottom: 45px;

      .item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .iconfont {
          margin-right: 6px;
          width: 13px;
          height: 13px;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          background: linear-gradient(179deg, #a7ef72 0%, #1ccc5d 100%);
        }
      }

      .item:last-child {
        margin-bottom: 0;
      }
    }

    .text-2 {
      margin-bottom: 81px;
      position: relative;
      padding-top: 7px;
      font-size: 10px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 18px;
    }

    .text-2::after {
      content: '';
      width: 14px;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.2);
      position: absolute;
      left: 0;
      top: 0;
    }

    .start-btn {
      height: 52px;
      background: #ff2c4c;
      box-shadow: 0px 5px 10px 0px rgba(255, 44, 76, 0.16);
      border-radius: 26px;
      text-align: center;
      line-height: 52px;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      margin-bottom: 17px;
    }

    .tips {
      text-align: center;
      font-size: 10px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 16px;
      .star {
        color: #ff411e;
      }
    }
  }
}
</style>
